import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  Button,
  FlexRow,
  Grid,
  Header3Text,
  NumberField,
  PhoneNumberField,
  SelectField,
  TextField,
} from 'ui-toolkit/index';
import { TaxYearInformations } from './TaxYearInformations';
import { StatesLabelValue } from '../../../ui-toolkit/enums/states';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';
import { FilterOptionOption } from 'react-select';

export interface IJurisdictionProps {
  index: number;
  canDelete: boolean;
  onRemove: () => void;
  baseName: string;
}

export const Jurisdiction: React.FC<IJurisdictionProps> = ({ index, onRemove, canDelete, baseName }) => {
  const stateFilterOptions = (option: FilterOptionOption<string>, inputValue: string) =>
    option.value.toLowerCase().includes(inputValue.toLowerCase());

  return (
    <Grid>
      <FlexRow justifyContent={'space-between'}>
        <Header3Text>Jurisdiction {index + 1}</Header3Text>
        {canDelete && (
          <Button
            intent="ghost"
            isInline
            onClick={onRemove}
            type="button"
            data-test-id={mergeTests(baseName, 'delete')}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        )}
      </FlexRow>
      <Grid columnCount={2}>
        <TextField
          name={`${baseName}.taxAuthority`}
          data-test-id={`${baseName}.taxAuthority`}
          label="Tax Authority"
          placeholder="Type here"
        />
        <TextField
          name={`${baseName}.payableTo`}
          data-test-id={`${baseName}.payableTo`}
          label="Payable To"
          placeholder="Type here"
        />
      </Grid>
      <Grid columnCount={5}>
        <TextField
          name={`${baseName}.streetAddress`}
          data-test-id={`${baseName}.streetAddress`}
          label="Tax Authority Street Address"
          placeholder="Type here"
        />
        <TextField
          name={`${baseName}.floorSuite`}
          data-test-id={`${baseName}.floorSuite`}
          label="Floor/Suite"
          placeholder="Type here"
        />
        <TextField name={`${baseName}.city`} data-test-id={`${baseName}.city`} label="City" placeholder="Type here" />
        <SelectField
          name={`${baseName}.state`}
          data-test-id={`${baseName}.state`}
          options={StatesLabelValue}
          filterOption={stateFilterOptions}
          label={`State`}
          placeholder={`Select one...`}
        />
        <NumberField
          name={`${baseName}.zipCode`}
          data-test-id={`${baseName}.zipCode`}
          label="Zip Code"
          placeholder="Type here"
        />
      </Grid>
      <Grid columnCount={2}>
        <PhoneNumberField
          name={`${baseName}.phoneNumber`}
          data-test-id={`${baseName}.phoneNumber`}
          label={'Phone Number'}
        />
        <NumberField
          name={`${baseName}.currentTaxYear`}
          data-test-id={`${baseName}.currentTaxYear`}
          label="Current Tax Year"
          placeholder="Type here"
        />
      </Grid>
      <TextField
        name={`${baseName}.collection`}
        data-test-id={`${baseName}.collection`}
        label="Collection"
        placeholder="Type here"
      />
      <Grid>
        <TaxYearInformations baseName={`${baseName}.taxYearInformation`} />
      </Grid>
    </Grid>
  );
};
